<template>
  <div class="club-page">
    <div class="tab-box">
      <ul class="tab-btn-list">
        <li v-for="(tab, index) in tabList" :key="index" :class="{active:currentTab === index}"
            @click="tabIndexChange(currentTab)">
          <a href="#" @click.prevent="currentTab = index">{{ tab }}</a>
        </li>
      </ul>
    </div>

    <div v-if="currentTab === 0" class="tab-content">
      <Emblem />
    </div>
    <div v-if="currentTab === 1" class="tab-content">
      <Identity />
    </div>
  </div>
</template>

<script>
import Emblem from '@/components/Club/Emblem.vue';
import Identity from '@/components/Club/Identity.vue';

export default {
  name: 'EmblemView',
  components: {Identity, Emblem},
  data() {
    return {
      currentTab: 0,
      tabList: ['엠블럼', '경영정체성'],

    }
  },
  mounted () {
  },
  methods: {
    tabIndexChange(val) {
    },
  }
}
</script>
